<template>
  <ion-page id="signoff-page">
    <ion-content>
      <TopLine :style="styleTopline" :title="signOffTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

      <div :style="styleMiddle">

        <ion-item>
          <h2>{{ signoffText }}</h2>
        </ion-item>
        <ion-item>
          <ion-checkbox label-placement="end" @ionChange="rememberEmail = !rememberEmail" checked>{{ translateEnglishWords("Remember my email address") }}</ion-checkbox>
        </ion-item>
      </div>
      <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonCheckbox,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
import { computed } from "@vue/reactivity"

import { ref, watch } from 'vue';
import { useConnectionStore } from '../../stores/connectionStore';
import { useWindowSizeStore } from '../../stores/windowSizeStore';
import { useRouter } from 'vue-router';
import { doStartupCheck } from '../../composables/startupCheck.js'
import TopLine from '@/components/TopLine.vue'
import Explain from '@/components/Explain.vue'

import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, 
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

import ToolBar from '@/components/ToolBar.vue'
import { translateEnglishWords } from '@/composables/translation';

const emit = defineEmits(['where-next','word-list','mic-is-muted'])

const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

const wordsSaid = computed({get() {return props.wordsSaid}})
const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")
const cookie = connectionStore.getCookie
const dummy = connectionStore.getDummy

const signoffText = ref(translateEnglishWords("Confirm Sign off"))

// if user isn't logged in, go to home screen
if (cookie == "" || dummy != 0) {
  emit("where-next","/")
}

const signOffTitle = ref(translateEnglishWords("Sign Off"))

  const wordlist = "command done remember email address confirm"
  emit("word-list",wordlist)

  const wordlistTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  //console.log("**** logoff initial screensize", windowSizeRef.value)

  const rememberEmail = ref(true)

  const TOOLBAR_CONFIRM = 0

  const toolbarElements = [
    { index : TOOLBAR_CONFIRM, label : translateEnglishWords("Confirm Sign off") ,disabled : false},
  ]
  const toolbarTrigger = ref(0)

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

   watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

  watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

  function doLogoff () {
    //console.log("****** LOGOFF")
    const connectionStore = useConnectionStore()
    connectionStore.setUserCookieDummy("","1")
    
    if (rememberEmail.value == false)
      connectionStore.setEmailAddress("")

    signoffText.value = translateEnglishWords("Signed off")
    toolbarElements[TOOLBAR_CONFIRM].disabled = true
    toolbarTrigger.value++
    doStartupCheck(true)

  }

   function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }
  
  function toolbarClick(arrayIndex) {
    if (arrayIndex == 0)
      processWords("command confirm")
    else
    processWords("command done")
  }

  function processWords(text) {
    //console.log("text in Logoff ",text)
    const returnArray = parseWordsSaid(text)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "done" :
        emit("where-next","/accountmenu")

        //router.replace({ path: "/accountmenu"})
        break;
      case "confirm" :
        doLogoff()
        break
      case "email" :
        rememberEmail.value = !rememberEmail.value
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }
        if (currentWord == "done") {
            return ["done",""]
        }
        if (currentWord == "confirm") {
            return ["confirm",""]
        }
        
        if (currentWord == "remember" || currentWord == "email" || currentWord == "address")
          return ["email", ""]

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
  }

  function parseWordsSaid(str) {
  
    const words = str.split(" ")

    //console.log("string ",str)
    //console.log("words",words,words.length)
    if (words.length == 0) {
        return ["ignore",""];
    }

    var currentWord = (words.length > 0) ? words[0] : "xyz"
    var nextWord = (words.length > 1) ? words[1] : "xyz"
    var nextNextWord = (words.length > 2) ? words[2] : "xyz"
          
    //console.log("current word",currentWord)

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore") {
            return ["ignore",""];
        }

        if (currentWord == "command") {
          const returnArray = parseCommands(words, i+1)
          return returnArray
        }
        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""]
  }

</script>

<style scoped>

ion-item {
  margin : 10px;
}

</style>